import {
  DoorStickerTemplate,
  FlyerTemplate,
  HELLOPRINT_SERVICE_LEVELS,
  PolygraphyProductType,
  StickerTemplate,
} from '../../../../../../../services/exports/Constants';
import { ProductOrderingSteps } from '../../../../../../../views/marketing/polygraphy/orders';

export default {
  title: 'Commander des produits imprimés',
  steps: {
    [ProductOrderingSteps.ProductInfo]: 'Détails du produit',
    [ProductOrderingSteps.ShippingInfo]: 'Informations de livraison',
    payment: 'Paiement',
  },
  form: {
    title: 'Détails de la commande',
    polygraphy_product_id: {
      label: 'Produit',
      placeholder: 'Sélectionner un produit',
      options: {
        [PolygraphyProductType.Flyer]: {
          name: 'Flyer - {{template}}',
          templates: {
            [FlyerTemplate.One]: 'Modèle n°1 🆕',
            [FlyerTemplate.Two]: 'Modèle n°2 🆕',
            [FlyerTemplate.Three]: 'Modèle n°3',
            [FlyerTemplate.Four]: 'Modèle n°4',
          },
        },
        [PolygraphyProductType.Sticker]: {
          name: 'Autocollant - {{template}}',
          templates: {
            [StickerTemplate.One]: 'Modèle n°1 🆕',
          },
        },
        [PolygraphyProductType.DoorSticker]: {
          name: 'Autocollant de porte - {{template}}',
          templates: {
            [DoorStickerTemplate.One]: 'Modèle n°1 🆕',
            [DoorStickerTemplate.Two]: 'Modèle n°2 🆕',
          },
        },
      },
    },
    quantity: {
      label: 'Quantité',
      placeholder: 'Saisir la quantité',
    },
    service_level: {
      label: 'Niveau de service',
      options: {
        [HELLOPRINT_SERVICE_LEVELS.SAVER]: 'Économique',
        [HELLOPRINT_SERVICE_LEVELS.STANDARD]: 'Standard',
        [HELLOPRINT_SERVICE_LEVELS.EXPRESS]: 'Express',
      },
    },
    shipping_company_name: {
      label: 'Société',
      placeholder: 'Saisir le nom de la société',
    },
    shipping_salutation: {
      label: 'Civilité',
      options: {
        mr: 'M.',
        mrs: 'Mme',
      },
    },
    shipping_first_name: {
      label: 'Prénom',
      placeholder: 'Entrez le prénom',
    },
    shipping_last_name: {
      label: 'Nom',
      placeholder: 'Entrez le nom',
    },
    shipping_country: {
      label: 'Pays',
      placeholder: 'Sélectionner le pays',
    },
    shipping_state: {
      label: 'État',
      placeholder: "Sélectionner l'état",
    },
    shipping_city: {
      label: 'Ville',
      placeholder: 'Entrez la ville',
    },
    shipping_address: {
      label: 'Adresse',
      placeholder: "Entrez l'adresse",
    },
    shipping_zip_code: {
      label: 'Code postal',
      placeholder: 'Entrez le code postal',
    },
    shipping_phone_number: {
      label: 'Numéro de téléphone',
      placeholder: 'Entrez le numéro de téléphone',
    },
    create_invoice: {
      options: {
        true: 'Facturation automatique – Débit immédiat',
        false: "Envoyer gratuitement – C'est un cadeau",
      },
    },
  },
  table: {
    title: 'Commandes précédentes',
    fields: {
      product: 'Produit',
      quantity: 'Quantité',
      status: 'Statut',
      service_level: 'Niveau de service',
      shipping: 'Livraison',
      tracking_url: 'URL de suivi',
      created: 'Créé',
      updated: 'Dernière mise à jour',
    },
  },
  labels: {
    shipping_company: 'Société',
    shipping_salutation: 'Civilité',
    shipping_first_name: 'Prénom',
    shipping_last_name: 'Nom',
    shipping_address: 'Adresse',
    shipping_zip_code: 'Code postal',
    shipping_city: 'Ville',
    shipping_phone_number: 'Numéro de téléphone',
    show_shipping_details: 'Détails de livraison',
    track_order: 'Suivre la commande',
    pending_from_provider: 'En attente du fournisseur',
  },
  modals: {
    confirmation: {
      title: 'Confirmer les détails de la commande',
    },
    free_order_confirmation: {
      title: 'Voulez-vous vraiment envoyer {{product}} gratuitement ?',
      description:
        "Vous avez choisi de ne pas facturer votre client aujourd'hui.\n Le produit sera expédié sans paiement.",
      buttons: {
        confirm: 'Oui, envoyer gratuitement',
      },
    },
  },
  buttons: {
    back_to_templates: 'Retour aux modèles',
    preview: 'Aperçu',
    next: 'Suivant',
    order: 'Créer une commande',
    confirm: 'Confirmer',
  },
  feedback: {
    shop_url_used: "Le produit inclut l'URL de la boutique en ligne (<url>{{url}}</url>). Est-ce intentionnel ?",
    order_total_price: 'Prix total des produits sélectionnés : <strong>{{amount}} HT</strong>',
  },
  toasts: {
    failed_to_create_order: 'Échec de la création de la commande',
    order_got_created: 'Commande créée',
    failed_to_load_data: 'Échec du chargement des données',
  },
};
